.container {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 16px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}
